/* tslint:disable */
/* eslint-disable */
/**
 * Product Page Aggregator
 * Aggregator for the product page on web and native apps
 *
 * The version of the OpenAPI document: 0
 * Contact: mark.salt@autotrader.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FinanceHeadlineOfferBreakdownFromJSON, FinanceHeadlineOfferBreakdownToJSON, } from './FinanceHeadlineOfferBreakdown';
import { PriceFromJSON, PriceToJSON, } from './Price';
import { CashPriceFromJSON, CashPriceToJSON, } from './CashPrice';
import { HeadingBadgeFromJSON, HeadingBadgeToJSON, } from './HeadingBadge';
import { HeadingPillsFromJSON, HeadingPillsToJSON, } from './HeadingPills';
/**
 * @export
 */
export const HeadingPriceIndicatorEnum = {
    Good: 'GOOD',
    Great: 'GREAT',
    High: 'HIGH',
    Low: 'LOW',
    Fair: 'FAIR',
    Noanalysis: 'NOANALYSIS'
};
/**
 * Check if a given object implements the Heading interface.
 */
export function instanceOfHeading(value) {
    if (!('priceIndicator' in value) || value['priceIndicator'] === undefined)
        return false;
    return true;
}
export function HeadingFromJSON(json) {
    return HeadingFromJSONTyped(json, false);
}
export function HeadingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'badge': json['badge'] == null ? undefined : HeadingBadgeFromJSON(json['badge']),
        'title': json['title'] == null ? undefined : json['title'],
        'subTitle': json['subTitle'] == null ? undefined : json['subTitle'],
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'adminFee': json['adminFee'] == null ? undefined : json['adminFee'],
        'adminFeeInfoDescription': json['adminFeeInfoDescription'] == null ? undefined : json['adminFeeInfoDescription'],
        'priceIndicator': json['priceIndicator'],
        'priceIndicatorLabel': json['priceIndicatorLabel'] == null ? undefined : json['priceIndicatorLabel'],
        'imported': json['imported'] == null ? undefined : json['imported'],
        'writeOffCategory': json['writeOffCategory'] == null ? undefined : json['writeOffCategory'],
        'financeHeadlineOffer': json['financeHeadlineOffer'] == null ? undefined : FinanceHeadlineOfferBreakdownFromJSON(json['financeHeadlineOffer']),
        'priceBreakdown': json['priceBreakdown'] == null ? undefined : CashPriceFromJSON(json['priceBreakdown']),
        'headingPills': json['headingPills'] == null ? undefined : (json['headingPills'].map(HeadingPillsFromJSON)),
    };
}
export function HeadingToJSON(json) {
    return HeadingToJSONTyped(json, false);
}
export function HeadingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'badge': HeadingBadgeToJSON(value['badge']),
        'title': value['title'],
        'subTitle': value['subTitle'],
        'price': PriceToJSON(value['price']),
        'adminFee': value['adminFee'],
        'adminFeeInfoDescription': value['adminFeeInfoDescription'],
        'priceIndicator': value['priceIndicator'],
        'priceIndicatorLabel': value['priceIndicatorLabel'],
        'imported': value['imported'],
        'writeOffCategory': value['writeOffCategory'],
        'financeHeadlineOffer': FinanceHeadlineOfferBreakdownToJSON(value['financeHeadlineOffer']),
        'priceBreakdown': CashPriceToJSON(value['priceBreakdown']),
        'headingPills': value['headingPills'] == null ? undefined : (value['headingPills'].map(HeadingPillsToJSON)),
    };
}
